import { render } from "./Footer.vue?vue&type=template&id=0e605a11&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=0e605a11&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3447251903/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e605a11"]])

export default __exports__